module.exports = __webpack_public_path__ + "static/media/green-quarter.e63f6532.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/green-quarter.jpg
// module id = 302
// module chunks = 0